var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6147 13.4992L13.2986 9.15772H9.08578V6.33578C9.08578 5.14867 9.67394 3.98869 11.5547 3.98869H13.497V0.29169C12.3659 0.111481 11.223 0.0139881 10.0774 0C6.61005 0 4.34632 2.08253 4.34632 5.84737V9.15772H0.502777V13.4992H4.34632V24H9.08578V13.4992H12.6147Z",
    fill: "#F05A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.3abfe04e1d6d2e6bc49b983efe5f27b1.svg";
export { ForwardRef as ReactComponent };